import { ReactNode } from 'react'

import { Wordmark } from './AuthLayout'

export interface ErrorLayoutProps {
  children: ReactNode
}

/** Samostatná chybová stránka mimo aplikaci (údržba, chyba přihlášení). */
export const ErrorLayout = ({ children }: ErrorLayoutProps) => (
  <div className="flex min-h-svh flex-col items-center bg-muted/40 px-4 py-10 sm:py-16">
    <div className="flex w-full max-w-[440px] flex-1 flex-col items-center gap-8 sm:justify-center sm:pb-[8vh]">
      <Wordmark />
      {children}
    </div>
  </div>
)

ErrorLayout.displayName = 'ErrorLayout'
